import React, { useEffect, useRef, useState } from "react";
import { Badge, Card, Form, InputGroup, ProgressBar, Table } from "react-bootstrap";
import Swal from "sweetalert2";
import { askReportFormat, saveReport } from "../../../../utils/reportExport";
import { useParams } from "react-router-dom";
import UseToggle from "../../../../Hooks/UseToggle";
import { studySiteDataEntryServices } from "../../../../APIServices/studySiteDataEntryServices";
import { studyOtherSettingsServices } from "../../../../APIServices/studyOtherSettingsServices";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studySiteManagementServices } from "../../../../APIServices/CTMS/SiteManagement/studySiteManagementServices";
import { studySubjectManagementServices } from "../../../../APIServices/CTMS/SubjectManagement/studySubjectManagementServices";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import ManagementFilterCanvas from "../../ManagementFilterCanvas";
import { studyLevelFormManagementServices } from "../../../../APIServices/studyLevelFormManagementServices";
import Pagination from "../../../Pagination";
import { usersOnboardingService } from "../../../../APIServices/usersOnboarding";
import AssignFormSDVReviewer from "./AssignFormSDVReviewer";
import TableProperties from "../TableProperties";
import SplitPane from "react-split-pane";
import { BsCheck2All, BsClock, BsFileText } from "react-icons/bs";
import { BiError, BiUserX } from "react-icons/bi";
import ReviewFormDataEntry from "./ReviewFormDataEntry";
import BulkReviewFormDataEntry from "./BulkReviewFormDataEntry";
import BulkAssignFormSDV from "./BulkAssignFormSDV";

const ManageFormSDVDataList = ({ onMouseDown, tableRef, handleAddNewTab }) => {
  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedSiteIds, setSelectedSiteIds] = useState([]);
  const [formSDVList, setFormSDVList] = useState([]);
  const [formSDVData, setFormSDVData] = useState("");
  const [formSDVListCount, setFormSDVListCount] = useState(0);
  const [totalCompletedSDV, setTotalCompletedSDV] = useState(0);
  const [totalTotalSDV, setTotalTotalSDV] = useState(0);
  const [totalOverdueSDV, setTotalOverdueSDV] = useState(0);
  const [totalUnassignedTasks, setTotalUnassignedTasks] = useState(0);
  const [totalPendingSDV, setTotalPendingSDV] = useState(0);
  const { toggle, setToggle, toggle2, setToggle2, toggle3, setToggle3, toggle4, setToggle4, toggle5, setToggle5, toggle6, setToggle6, toggle7, setToggle7 } = UseToggle();
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [tableColumns, setTableColumns] = useState({});
  let { studyId } = useParams();
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [siteList, setSiteList] = useState([]);
  const [subjectList, setSubjectList] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [siteId, setSiteId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [eventId, setEventId] = useState("");
  const [timePointId, setTimePointId] = useState("");
  const [status, setStatus] = useState("ALL");
  const [formList, setFormList] = useState([]);
  const [formId, setFormId] = useState("");
  const [repeatEvent, setRepeatEvent] = useState("");
  const [repeatForm, setRepeatForm] = useState("");
  const [filterStatus, setFilterStatus] = useState("ALL");
  const emptyFilters = { siteId: "", subjectId: "", eventId: "", timePointId: "", formId: "", repeatEvent: "", repeatForm: "" };
  // Filters actually applied to the list; the offcanvas edits the draft states above until "Filter selection"
  const [appliedFilters, setAppliedFilters] = useState(emptyFilters);
  const latestListRequest = useRef(0);
  const [userList, setUserList] = useState([]);
  const [sdvUserList, setSdvUserList] = useState([]);
  const LoginCat = JSON.parse(localStorage.getItem("role")).toLowerCase();

  const studyPermission = JSON.parse(localStorage.getItem("studyPermissionData"));

  const formColumn = [
    { columnLabel: "SiteId", columnName: "SITEID", columnType: "text" },
    { columnLabel: "SubjectId", columnName: "SUBJECTID", columnType: "text" },
    { columnLabel: "EventId", columnName: "EVENTID", columnType: "text" },
    { columnLabel: "TimepointId", columnName: "TIMEPOINTID", columnType: "text" },
    { columnLabel: "Repeat Event", columnName: "REPEATEVENT", columnType: "text" },
    { columnLabel: "Form Name", columnName: "FORMNAME", columnType: "text" },
    { columnLabel: "Form Version", columnName: "FORMVERSION", columnType: "text" },
    { columnLabel: "Form Type", columnName: "FORMTYPE", columnType: "text" },
    { columnLabel: "Repeat Form", columnName: "REPEATFORM", columnType: "text" },
    { columnLabel: "Data Entry Mode", columnName: "DATAENTRYMODE", columnType: "text" },
    { columnLabel: "Updated Version", columnName: "UPDATEDVERSION", columnType: "text" },
    { columnLabel: "Assigned User", columnName: "ASSIGNEDUSER", columnType: "array" },
    { columnLabel: "Due Date", columnName: "DUEDATE", columnType: "text" },
    { columnLabel: "Overdue", columnName: "OVERDUE", columnType: "text" },
    { columnLabel: "Status", columnName: "STATUS", columnType: "text" },
    { columnLabel: "Completed Status", columnName: "COMPLETEDSTATUS", columnType: "text" },
  ];

  const handleSelect = (row) => {
    const { _id, siteId } = row;

    if (selectedIds.includes(_id)) {
      setSelectedIds((prev) => prev.filter((id) => id !== _id));
      setSelectedSiteIds((prev) => prev.filter((id) => id !== siteId));
    } else {
      setSelectedIds((prev) => [...prev, _id]);
      setSelectedSiteIds((prev) => [...new Set([...prev, siteId])]);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedIds(formSDVList.map((item) => item._id));

      setSelectedSiteIds([
        ...new Set(formSDVList.map((item) => item.siteId)),
      ]);
    } else {
      setSelectedIds([]);
      setSelectedSiteIds([]);
    }
  };

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(formSDVListCount / itemsPerPage);

  const getStudyFormSDVList = async () => {
    const requestId = ++latestListRequest.current;
    setLoading(true);
    let userData = {};
    userData.studyId = studyId;
    userData.mode = StudyMode;
    userData.status = status;
    userData.page = pageNumber;
    userData.length = itemsPerPage;
    userData = { ...userData, ...appliedFilters };
    userData.type = (studyPermission?.liveTaskSDVFormSignature || studyPermission?.qcTaskSDVFormSignature || StudyMode === "DBP Mode") ? "ALL" : "MY";
    let data = await studySiteDataEntryServices.getStudyFormSDVList(
      userData
    );
    // A slower, older request must not overwrite the result of the latest filters
    if (requestId !== latestListRequest.current) return;
    setFormSDVList(data?.data || []);
    setFormSDVListCount(data?.count || 0);
    setTotalCompletedSDV(data?.completedCount || 0);
    setTotalPendingSDV(data?.pendingCount || 0);
    setTotalTotalSDV(data?.totalCount || 0);
    setTotalOverdueSDV(data?.overdueCount || 0);
    setTotalUnassignedTasks(data?.unassignedTask || 0);
    setLoading(false);
  };

  const downloadSDVReport = async () => {
    const format = await askReportFormat();
    if (!format) return;
    setExportLoading(true);
    try {
      const response = await studySiteDataEntryServices.getStudyFormSDVList({
        studyId,
        mode: StudyMode,
        ...appliedFilters,
        status: "ALL",
        type: (studyPermission?.liveTaskSDVFormSignature || studyPermission?.qcTaskSDVFormSignature || StudyMode === "DBP Mode") ? "ALL" : "MY",
      });
      const reportData = Array.isArray(response?.data) ? response.data : [];
      if (!reportData.length) {
        await Swal.fire({
          icon: "info",
          title: "No SDV data",
          text: response?.customMessage || "No SDV data is available for this report.",
        });
        return;
      }

      const columns = [
        { label: "Sr.", value: (_, index) => index + 1 },
        { key: "SITEID", label: "SiteId", value: (item) => item?.siteName },
        { key: "SUBJECTID", label: "SubjectId", value: (item) => `${item?.subjectName || ""}${item?.subjectVoid ? " (VOID)" : ""}` },
        { key: "EVENTID", label: "EventId", value: (item) => item?.dataEntryType === "specialForm" ? "Special Form" : item?.eventName },
        { key: "TIMEPOINTID", label: "TimepointId", value: (item) => item?.timePointId || "_" },
        { key: "REPEATEVENT", label: "Repeat Event", value: (item) => item?.repeatEvent },
        { key: "FORMNAME", label: "Form Name", value: (item) => item?.formName },
        { key: "FORMVERSION", label: "Form Version", value: (item) => `v${item?.formVersion}` },
        { key: "FORMTYPE", label: "Form Type", value: (item) => item?.formType },
        { key: "REPEATFORM", label: "Repeat Form", value: (item) => item?.repeatForm },
        { key: "DATAENTRYMODE", label: "Data Entry Mode", value: (item) => item?.dataEntryType === "eventForm" ? "Event Form" : item?.dataEntryType === "specialForm" ? "Special Form" : "Initiate Form" },
        { key: "UPDATEDVERSION", label: "Review Version", value: (item) => item?.updatedVersion },
        { key: "ASSIGNEDUSER", label: "Assigned User", value: (item) => (item?.assignedUser || []).map((userId) => userList.find((user) => user?.userId === userId)?.fullName || userId).join(", ") },
        { key: "DUEDATE", label: "Due Date", value: (item) => item?.dueDate || "_" },
        { key: "OVERDUE", label: "Overdue", value: (item) => item?.dueDate ? item?.isOverdue : "_" },
        { key: "STATUS", label: "Status", value: (item) => item?.status },
        { key: "COMPLETEDSTATUS", label: "Sign Count", value: (item) => `${item?.completedStatus || 0}%` },
      ].filter((column) => !column.key || !tableColumns[column.key]);
      const csvRows = [
        columns.map((column) => column.label),
        ...reportData.map((item, index) => columns.map((column) => column.value(item, index) ?? "")),
      ];
      saveReport(csvRows, format, "SDV_Report");
    } catch (error) {
      await Swal.fire({
        icon: "error",
        title: "Report download failed",
        text: error?.message || "Unable to export SDV report.",
      });
    } finally {
      setExportLoading(false);
    }
  };

  const getTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getTablePropertiesData(
      "studyLevelFormSDVManagement",
      studyId
    );
    setTableColumns(data?.data || {});
  };

  const getStudySiteBasedonAccess = async () => {
    let data = await studySiteManagementServices.getStudySiteBasedonAccess(studyId, LoginCat, StudyMode)
    setSiteList(data?.data || [])
  }

  const getStudySubjectRowData = async () => {
    let data = await studySubjectManagementServices.getStudySubjectRowData("active", studyId, siteId, StudyMode)
    setSubjectList(data?.data || [])
  }

  const getStudyEventRowData = async () => {
    let data = await studyEventManagementServices.getStudyEventRowData("active", studyId)
    setEventList(data?.data || [])
  }

  const getAssignedAppUser = async () => {
    let data = await usersOnboardingService.getAssignedAppUser(studyId, "edc")
    setUserList(data?.data || [])
  }

  const getAssignedAppModeUser = async () => {
    let data = await usersOnboardingService.getAssignedAppModeUser(studyId, "edc", StudyMode)
    setSdvUserList(data?.data || [])
  }

  const getStudyLevelForm = async () => {
    let data = await studyLevelFormManagementServices.getStudyLevelForm(studyId, "edc", "active", StudyMode)
    setFormList(data?.data || [])
  }

  const statusOptions = [
    { label: "All", value: "ALL" },
    { label: "Pending", value: "pending" },
    { label: "Completed", value: "completed" },
    { label: "Overdue", value: "overdue" },
    { label: "Unassigned", value: "unassigned" },
  ];

  useEffect(() => {
    getTablePropertiesData();
    getStudySiteBasedonAccess()
    getStudyEventRowData()
    getAssignedAppUser()
    getAssignedAppModeUser()
    getStudyLevelForm()
  }, []);

  useEffect(() => {
    if (siteId) {
      getStudySubjectRowData();
    } else {
      setSubjectList([]);
    }
  }, [siteId]);

  useEffect(() => {
    setSelectedIds([])
    setSelectedSiteIds([])
  }, [status, appliedFilters]);

  useEffect(() => {
    getStudyFormSDVList();
  }, [status, pageNumber, itemsPerPage, appliedFilters]);

  const changeStatus = (newStatus) => {
    setStatus(newStatus);
    setFilterStatus(newStatus);
    setPageNumber(1);
  };

  const setDraftFilters = (filters) => {
    setSiteId(filters.siteId);
    setSubjectId(filters.subjectId);
    setEventId(filters.eventId);
    setTimePointId(filters.timePointId);
    setFormId(filters.formId);
    setRepeatEvent(filters.repeatEvent);
    setRepeatForm(filters.repeatForm);
  };

  const openFilter = () => {
    if (toggle) {
      setDraftFilters(appliedFilters);
      setFilterStatus(status);
    }
    setToggle();
  };

  const applyFilters = () => {
    setAppliedFilters({ siteId, subjectId, eventId, timePointId, formId, repeatEvent, repeatForm });
    setStatus(filterStatus);
    setPageNumber(1);
  };

  const resetFilters = () => {
    setDraftFilters(emptyFilters);
    setFilterStatus("ALL");
    setAppliedFilters(emptyFilters);
    setStatus("ALL");
    setPageNumber(1);
  };

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to Update Table Property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.studyId = studyId;
        userData.type = "studyLevelFormSDVManagement";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(
          userData
        );
        if (data?.statusCode === 200) {
          getStudyFormSDVList();
          getTablePropertiesData();
        }
      }
    });
  };

  const overviewCards = [
    {
      title: "Total Tasks",
      value: totalTotalSDV,
      subtitle: "All review tasks assigned for completion",
      icon: <BsFileText className="bg-white text-info shadow-sm" />,
    },
    {
      title: "Pending Tasks",
      value: totalPendingSDV,
      subtitle: "Awaiting review and pending completion",
      icon: <BsClock className="bg-white text-warning shadow-sm" />,
    },
    {
      title: "Completed Tasks",
      value: totalCompletedSDV,
      subtitle: "Successfully reviewed and completed",
      icon: <BsCheck2All className="bg-white text-success shadow-sm" />,
    },
    {
      title: "Overdue Tasks",
      value: totalOverdueSDV,
      subtitle: "Past due and awaiting completion",
      icon: <BiError className="bg-white text-danger shadow-sm" />,
    },
    {
      title: "Unassigned Tasks",
      value: totalUnassignedTasks,
      subtitle: "Tasks awaiting reviewer assignment",
      icon: <BiUserX className="bg-white text-warning shadow-sm" />,
    },
  ];

  return (
    <>
      <div className="p-2 chart__overview hstack justify-content-between gap-3">
        {overviewCards?.map((item, index) => (
          <div key={index} className="h-100 w-100">
            <Card className="app-card bg-light border">
              <Card.Body>
                <div className="d-flex gap-3">
                  <div className="study_icopn">{item.icon}</div>
                  <div>
                    <Card.Title style={{ fontSize: 16 }}>{item.title}</Card.Title>
                    <Card.Text className="m-0">{item.value || "0"}</Card.Text>
                    <Card.Text style={{ fontSize: 11 }}>{item.subtitle}</Card.Text>
                  </div>
                </div>
              </Card.Body>
            </Card>
          </div>
        ))}
      </div>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1 bg-white"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          <InputGroup className="w-auto">
            <button style={{ fontSize: 9 }} title="Open Filter" onClick={openFilter} className={`updateProfile ${!toggle ? "activee" : ""}`}>
              <i className="fa-solid fa-filter"></i>
            </button>
            <button onClick={() => changeStatus("ALL")} className={`updateProfile ${status === "ALL" ? "activee" : ""}`}>
              All
            </button>
            <button onClick={() => changeStatus("pending")} className={`updateProfile ${status === "pending" ? "activee" : ""}`}>
              Pending
            </button>
            <button onClick={() => changeStatus("completed")} className={`updateProfile ${status === "completed" ? "activee" : ""}`}>
              Completed
            </button>
            <button onClick={() => changeStatus("overdue")} className={`updateProfile ${status === "overdue" ? "activee" : ""}`}>
              Overdue
            </button>
            <button onClick={() => changeStatus("unassigned")} className={`updateProfile ${status === "unassigned" ? "activee" : ""}`}>
              Unassigned
            </button>
          </InputGroup>
        </div>
        <div className="hstack gap-2">
          {formSDVListCount > 0 && (
            <div className="gap-1 hstack">
              <button
                type="button"
                onClick={downloadSDVReport}
                className="updateProfile"
                disabled={exportLoading}
              >
                <i className="fa-solid fa-download me-1" aria-hidden="true" />
                {exportLoading ? "Preparing Report..." : "Download Report"}
              </button>
              <button
                onClick={() => {
                  setToggle2();
                  getTablePropertiesData();
                }}
                className={`updateProfile`}
              >
                Table Properties
              </button>
            </div>
          )}
          {(status === "pending" && formSDVListCount > 0 && (StudyMode?.startsWith("SDV") || StudyMode === "DBP Mode")) &&
            <button disabled={selectedIds?.length === 0} onClick={setToggle5} className="updateProfile">Bulk Review</button>
          }
          {(status === "overdue" && formSDVListCount > 0 && (StudyMode === "Live Mode" || StudyMode === "QC Mode" || StudyMode === "DBP Mode")) &&
            <button disabled={selectedIds?.length === 0} onClick={setToggle7} className="updateProfile">Bulk Update Due Date</button>
          }
          {((status === "pending" || status === "overdue" || status === "unassigned") && formSDVListCount > 0 && (studyPermission?.liveTaskSDVFormSignature || studyPermission?.qcTaskSDVFormSignature || StudyMode === "DBP Mode")) &&
            <button disabled={selectedIds?.length === 0} onClick={setToggle6} className="updateProfile">Bulk Assign</button>
          }
        </div>
      </div>
      <SplitPane
        split="vertical"
        minSize={"100%"}
        className="position-relative"
        style={{ height: "calc(100vh - 308px)" }}
      >
        {loading ? (
          <PageLoader />
        ) : formSDVListCount === 0 ? (
          <NoDataFoundTable MSG={"SDV data list not found!"} />
        ) : (
          <>
            <Table ref={tableRef} className="m-0 custom-table w-auto" hover striped bordered>
              <thead className="position-sticky top-0 z-1">
                <tr>
                  {(status === "pending" || status === "overdue" || status === "unassigned") ?
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      <Form.Check
                        checked={
                          formSDVList?.length > 0 &&
                          selectedIds.length === formSDVList.length
                        }
                        onChange={handleSelectAll}
                      />
                    </th>
                    :
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                  }
                  {!tableColumns["SITEID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>SiteId</th>
                  )}
                  {!tableColumns["SUBJECTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>SubjectId</th>
                  )}
                  {!tableColumns["EVENTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>EventId</th>
                  )}
                  {!tableColumns["TIMEPOINTID"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 4)}>TimepointId</th>
                  )}
                  {!tableColumns["REPEATEVENT"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 5)}>Repeat Event</th>
                  )}
                  {!tableColumns["FORMNAME"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 6)}>Form Name</th>
                  )}
                  {!tableColumns["FORMVERSION"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 7)}>Form Version</th>
                  )}
                  {!tableColumns["REPEATFORM"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 8)}>Repeat Form</th>
                  )}
                  {!tableColumns["FORMTYPE"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 9)}>Form Type</th>
                  )}
                  {!tableColumns["DATAENTRYMODE"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 10)}>Data Entry Mode</th>
                  )}
                  {!tableColumns["UPDATEDVERSION"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 11)}>Review Version</th>
                  )}
                  {!tableColumns["ASSIGNEDUSER"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 12)}>Assigned User</th>
                  )}
                  {!tableColumns["DUEDATE"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 13)}>Due Date</th>
                  )}
                  {!tableColumns["OVERDUE"] && (
                    <th onMouseDown={(e) => onMouseDown(e, 14)}>Overdue</th>
                  )}
                  {!tableColumns["STATUS"] && (
                    <th
                      style={{ width: 100 }}
                      onMouseDown={(e) => onMouseDown(e, 15)}
                    >
                      Status
                    </th>
                  )}
                  {!tableColumns["COMPLETEDSTATUS"] && (
                    <th
                      style={{ width: 100 }}
                      onMouseDown={(e) => onMouseDown(e, 16)}
                    >
                      Sign Count
                    </th>
                  )}
                  {(StudyMode === "DBP Mode" || studyPermission?.liveTaskSDVFormSignature || studyPermission?.qcTaskSDVFormSignature) &&
                    <th
                      onMouseDown={(e) => onMouseDown(17)}
                      className="text-center"
                      style={{ width: 100 }}
                    >
                      Assign Reviewer
                    </th>
                  }
                  <th
                    onMouseDown={(e) => onMouseDown(e, (StudyMode === "DBP Mode" || studyPermission?.liveTaskSDVFormSignature || studyPermission?.qcTaskSDVFormSignature) ? 18 : 17)}
                    style={{ width: 80 }}
                    className="text-center"
                  >
                    View Form
                  </th>
                  {(status === "pending" && formSDVListCount > 0 && (StudyMode === "DBP Mode" || StudyMode?.startsWith("SDV"))) &&
                    <th
                      onMouseDown={(e) => onMouseDown(e, (StudyMode === "DBP Mode" || studyPermission?.liveTaskSDVFormSignature || studyPermission?.qcTaskSDVFormSignature) ? 19 : 18)}
                      style={{ width: 80 }}
                      className="text-center"
                    >
                      Sign Now
                    </th>
                  }
                </tr>
              </thead>
              <tbody>
                {formSDVList?.map((item, index) => (
                  <tr key={index} title="View Details">
                    {(status === "pending" || status === "overdue" || status === "unassigned") ?
                      <td className="text-center">
                        <Form.Check
                          checked={selectedIds.includes(item._id)}
                          onChange={() => handleSelect(item)}
                        />
                      </td>
                      :
                      <td className="text-center">{index + 1 + startIndex}.</td>
                    }
                    {!tableColumns["SITEID"] && <td>{item?.siteName}</td>}
                    {!tableColumns["SUBJECTID"] && (
                      <td>{item?.subjectName} {item?.subjectVoid ? "(VOID)" : ""}</td>
                    )}
                    {!tableColumns["EVENTID"] && (
                      item?.dataEntryType === "specialForm" ?
                        <td>
                          Special Form
                        </td>
                        :
                        <td>
                          {item?.eventName}
                        </td>
                    )}
                    {!tableColumns["TIMEPOINTID"] && (
                      <td>
                        {item?.timePointId ? item?.timePointId : "_"}
                      </td>
                    )}
                    {!tableColumns["REPEATEVENT"] && (
                      <td>
                        {item?.repeatEvent}
                      </td>
                    )}
                    {!tableColumns["FORMNAME"] && (
                      <td>
                        {item?.formName}
                      </td>
                    )}
                    {!tableColumns["FORMVERSION"] && (
                      <td>
                        v{item?.formVersion}
                      </td>
                    )}
                    {!tableColumns["REPEATFORM"] && (
                      <td className="text-capitalize">
                        {item?.repeatForm}
                      </td>
                    )}
                    {!tableColumns["FORMTYPE"] && (
                      <td className="text-capitalize">
                        {item?.formType}
                      </td>
                    )}
                    {!tableColumns["DATAENTRYMODE"] && (
                      <td>
                        {item?.dataEntryType === "eventForm" ? "Event Form" : item?.dataEntryType === "specialForm" ? "Special Form" : "Initiate Form"}
                      </td>
                    )}
                    {!tableColumns["UPDATEDVERSION"] && (
                      <td className="text-capitalize">
                        {item?.updatedVersion}
                      </td>
                    )}
                    {!tableColumns["ASSIGNEDUSER"] && (
                      <td>
                        {(item?.assignedUser || [])?.map((userId) => {
                          const user = userList?.find(
                            (u) => u?.userId === userId
                          );
                          return (
                            <div key={userId}>
                              {user?.fullName}
                            </div>
                          );
                        })}
                      </td>
                    )}
                    {!tableColumns["DUEDATE"] && (
                      <td>
                        {item?.dueDate || "_"}
                      </td>
                    )}
                    {!tableColumns["OVERDUE"] && (
                      item?.dueDate ?
                        <td className={`fw-bold text-capitalize ${item?.isOverdue === "yes" ? "text-danger" : "text-success"}`}>
                          {item?.isOverdue}
                        </td>
                        :
                        <td>
                          _
                        </td>
                    )}
                    {!tableColumns["STATUS"] && (
                      <td
                        className={`text-capitalize fw-bold ${item?.status === "completed"
                          ? "text-success"
                          : "text-muted"
                          }`}
                      >
                        {item?.status}
                      </td>
                    )}
                    {!tableColumns["COMPLETEDSTATUS"] && (
                      <td
                        className={`fw-bold`}
                      >
                        <ProgressBar now={item?.completedStatus} />
                      </td>
                    )}
                    {(studyPermission?.liveTaskSDVFormSignature || studyPermission?.qcTaskSDVFormSignature || StudyMode === "DBP Mode") &&
                      <td className={`text-capitalize text-center`}>
                        <button
                          disabled={item?.reviewArray > 0}
                          onClick={() => {
                            setToggle3();
                            setFormSDVData(item);
                          }}
                          className={`updateProfile`}
                          style={{ padding: "1px 10px" }}
                        >
                          {item?.assignedUser?.length > 0 ? "Re-Assign" : "Assign Now"}
                        </button>
                      </td>
                    }
                    <td className={`text-capitalize text-center`}>
                      <button
                        onClick={() =>
                          handleAddNewTab(
                            item?.dataEntryType === "specialForm" ?
                              `Site: ${item?.siteName} - Subject: ${item?.subjectName} ${item?.subjectVoid ? "(VOID)" : ""} - Event: Special Event` :
                              item?.timePointId ?
                                `Site: ${item?.siteName} - Subject: ${item?.subjectName} ${item?.subjectVoid ? "(VOID)" : ""} - Event: ${item?.eventName} (${item?.timePointId}) ${item?.repeatEvent > 0 ? `(R${item?.repeatEvent})` : ""}` :
                                `Site: ${item?.siteName} - Subject: ${item?.subjectName} ${item?.subjectVoid ? "(VOID)" : ""} - Event: ${item?.eventName} ${item?.repeatEvent > 0 ? `(R${item?.repeatEvent})` : ""}`,
                            "",
                            item?.dataEntryType === "specialForm" ?
                              `viewEventSchemaFormLists_${item?.siteId}_${item?.subjectId}_${item?.subjectId}SpecialForm`
                              : item?.timePointUniqueId ?
                                `viewEventSchemaFormLists_${item?.siteId}_${item?.subjectId}_${item?.eventId}_repeatEventId_${item?.timePointUniqueId}_repeatTimePointId`
                                : `viewEventSchemaFormLists_${item?.siteId}_${item?.subjectId}_${item?.eventId}_repeatEventId`,
                            {
                              siteId: item?.siteId,
                              siteName: item?.siteName,
                              subjectId: item?.subjectId,
                              subjectName: item?.subjectName,
                              schemaId: item?.schemaId,
                              formId: item?.formId,
                              formName: item?.formName,
                              formVersion: item?.formVersion,
                              formType: item?.formType,
                              recordId: item?.recordId,
                              type: item?.dataEntryType,
                              autoForm: "yes",
                              viewType: "dataEntry",
                              eventId: item?.eventId,
                              eventName: item?.eventName,
                              timePointUniqueId: item?.timePointUniqueId
                                ? String(item?.timePointUniqueId)
                                : "",
                              timePointId: item?.timePointUniqueId
                                ? item?.timePointId
                                : "",
                              repeatEventId: "",
                              repeatTimePointId: ""
                            }
                          )
                        }
                        className={`updateProfile`}
                        style={{ padding: "1px 10px" }}
                      >
                        View
                      </button>
                    </td>
                    {(status === "pending" && formSDVListCount > 0 && (StudyMode?.startsWith("SDV") || StudyMode === "DBP Mode")) &&
                      <td className={`text-capitalize text-center`}>
                        <button
                          onClick={() => {
                            setToggle4();
                            setFormSDVData(item);
                          }}
                          disabled={item?.signButton}
                          className={`updateProfile`}
                          style={{ padding: "1px 10px" }}
                        >
                          Sign Now
                        </button>
                      </td>
                    }
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="position-sticky bottom-0 start-0">
              <Pagination
                totalPage={totalPage}
                pageNumber={pageNumber}
                itemsPerPage={itemsPerPage}
                totalItems={formSDVListCount}
                setPageNumber={setPageNumber}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </>
        )}
      </SplitPane>
      <ReviewFormDataEntry
        Show={!toggle4}
        Hide={setToggle4}
        Title={"Review Form"}
        formSDVData={formSDVData}
        getStudyFormSDVList={getStudyFormSDVList}
      />
      <BulkReviewFormDataEntry
        Show={!toggle5}
        Hide={setToggle5}
        Title={"Bulk Review Form"}
        setSelectedIds={setSelectedIds}
        selectedIds={selectedIds}
        setSelectedSiteIds={setSelectedSiteIds}
        selectedSiteIds={selectedSiteIds}
        getStudyFormSDVList={getStudyFormSDVList}
        studyId={studyId}
      />
      <AssignFormSDVReviewer
        Show={!toggle3}
        Hide={setToggle3}
        Title={"Assign SDV Reviewer"}
        formSDVData={formSDVData}
        setUserList={setUserList}
        userList={sdvUserList}
        getStudyFormSDVList={getStudyFormSDVList}
      />
      <BulkAssignFormSDV
        Show={!toggle6}
        Hide={setToggle6}
        Title={"Bulk Assign SDV Reviewer"}
        type={"assignedUser"}
        userList={sdvUserList}
        setSelectedIds={setSelectedIds}
        selectedIds={selectedIds}
        setSelectedSiteIds={setSelectedSiteIds}
        selectedSiteIds={selectedSiteIds}
        getStudyFormSDVList={getStudyFormSDVList}
      />
      <BulkAssignFormSDV
        Show={!toggle7}
        Hide={setToggle7}
        Title={"Bulk Assign Due Date"}
        type={"dueDate"}
        userList={[]}
        setSelectedIds={setSelectedIds}
        selectedIds={selectedIds}
        setSelectedSiteIds={setSelectedSiteIds}
        selectedSiteIds={selectedSiteIds}
        getStudyFormSDVList={getStudyFormSDVList}
      />
      <TableProperties
        Show={!toggle2}
        Hide={setToggle2}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formColumn={formColumn}
        tableColumns={tableColumns}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />
      <ManagementFilterCanvas
        Show={!toggle}
        Hide={setToggle}
        Title={"Filter"}
        siteList={siteList}
        subjectList={subjectList}
        eventList={eventList}
        siteId={siteId}
        setSiteId={setSiteId}
        subjectId={subjectId}
        setSubjectId={setSubjectId}
        eventId={eventId}
        setEventId={setEventId}
        timePointId={timePointId}
        setTimePointId={setTimePointId}
        formList={formList}
        formId={formId}
        setFormId={setFormId}
        repeatEvent={repeatEvent}
        setRepeatEvent={setRepeatEvent}
        repeatForm={repeatForm}
        setRepeatForm={setRepeatForm}
        statusOptions={statusOptions}
        status={filterStatus}
        setStatus={setFilterStatus}
        onApply={applyFilters}
        onReset={resetFilters}
      />
    </>
  );
};

export default ManageFormSDVDataList;
